<template>
  <v-flex xs12 sm6 lg3 v-resize="onResize">
    <v-card>
      <v-card-media class="pa-2" ref="card">
        <div :style="{width: width+'px'}">
          <resource-graph :active="active" :resource="resource"/>
        </div>
      </v-card-media>
      <v-card-text>
        <h2 v-if="$t(`resources.identifiers.${resource.resourceIdentifier}`).includes('resources.identifiers')">
          <v-icon class="pr-2">{{resourceIconMap['DEFAULT']}}</v-icon>
          {{$t(`${resource.resourceIdentifier}`)}}
        </h2>
        <h2 v-else>
          <v-icon>{{resourceIconMap[resource.resourceIdentifier]}}</v-icon>
          {{$t(`resources.identifiers.${resource.resourceIdentifier}`)}}
        </h2>
        <h3 v-if="!isStudent"
            class="caption">{{$t('resources.identifiers.average')}} {{resource.courseAverage.toFixed(1)}}</h3>
      </v-card-text>
      <div class="resource-count display-3">{{resource.resourceCount}}</div>
    </v-card>
  </v-flex>
</template>

<script>
  import ResourceGraph from './ResourceGraph'
  import throttle from 'lodash.throttle'
  import Roles from '../../mixins/Roles'

  export default {
    components: {ResourceGraph},
    name: 'resource-card',
    props: {
      active: {
        type: Boolean,
        required: true
      },
      resource: {
        type: Object,
        required: true
      },
      resourceIconMap: {
        type: Object,
        required: true
      }
    },
    mixins: [Roles],
    data () {
      return {
        width: 100
      }
    },
    methods: {},
    computed: {
      onResize () {
        return throttle(() => {
          this.width = this.$refs.card.$el.offsetWidth - 16
        }, 50, {trailing: true})
      }
    },
    watch: {
      active (value) {
        if (value) {
          this.onResize()
        }
      }
    },
    mounted () {
      this.onResize()
    }
  }
</script>

<style scoped>
  .resource-count {
    position: absolute;
    bottom: -8px;
    right: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/resources/ResourceCard.vue